<div class="text-center">
    <p>404</p>
    <div>{{'error.404' | translate}}</div>
    <button class="btn btn--primary" routerLink="/">
      {{'action.back_home' | translate}}
    </button>
</div>
